import React from "react";
import { Icon, type IconName } from "../Icon";
import { Spinner } from "./Spinner";

// `secondary` = Back-Compat-Alias fuer `outline` (aus Legacy `~/component/button`);
// rendert identisch zu outline, damit dynamische `variant={cond ? "primary" : "secondary"}`
// Call-Sites verlustfrei migrieren.
export type ButtonVariant =
  | "primary"
  | "outline"
  | "ghost"
  | "danger"
  | "danger-outline"
  | "success"
  | "warning"
  | "secondary"
  | "ai";
export type ButtonSize = "sm" | "md" | "lg";

interface ButtonProps extends Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, "type"> {
  variant?: ButtonVariant;
  size?: ButtonSize;
  iconName?: IconName;
  iconRight?: IconName;
  loading?: boolean;
  type?: "button" | "submit" | "reset";
}

export const Button: React.FC<ButtonProps> = ({
  variant = "outline",
  size = "md",
  iconName,
  iconRight,
  loading = false,
  type = "button",
  children,
  className = "",
  disabled,
  ...rest
}) => {
  const variantClass = variant === "secondary" ? "outline" : variant;
  const sizeClass = size === "sm" ? " ds-btn-sm" : size === "lg" ? " ds-btn-lg" : "";
  const iconSize = size === "lg" ? 15 : size === "sm" ? 13 : 14;
  return (
    <button
      type={type}
      disabled={disabled || loading}
      className={`ds-btn ds-btn-${variantClass}${sizeClass} ${className}`}
      {...rest}
    >
      {loading ? (
        <Spinner size="xs" tone="current" />
      ) : (
        iconName && <Icon name={iconName} size={iconSize} />
      )}
      {children}
      {iconRight && <Icon name={iconRight} size={iconSize} />}
    </button>
  );
};
